// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3B2sM","info":"UpdateTermsInfo_info__20YsC"};